import { ComponentProps, FC } from 'react'
import { styled } from '../../../config'
import { CloudUpload } from '../../../icons'

const StyledCloudUpload = styled(CloudUpload, { color: '$white ' })

export const Icon: FC<ComponentProps<typeof StyledCloudUpload>> = (props) => {
  return <StyledCloudUpload {...props} />
}
